import omit from 'lodash/omit';
import { v4 as uuid } from 'uuid';

import { isEqual } from 'bones/utils/isEqual';
import { DatatypeOperatorType } from 'bones/utils/queryBuilder/constants';
import {
  DraftTopExpression,
  Filter,
  TopExpression,
} from 'bones/utils/queryBuilder/types';

export const removeDraftFields = ({
  expressions,
  ...topExpression
}: DraftTopExpression): TopExpression => ({
  ...topExpression,
  expressions: expressions.map(({ id: _, expressions, ...subExpression }) => ({
    ...subExpression,
    expressions: expressions.map(({ id: _, filters, ...expression }) => ({
      ...expression,
      filters: filters.map(
        ({
          id: _,
          isInvalid: __,
          tooltip: ___,
          comparisonOperator,
          comparisonSubject,
          value,
          ...filter
        }) =>
          (filter.operator?.comparison
            ? {
                ...filter,
                comparisonSubject,
                comparisonOperator,
              }
            : {
                ...filter,
                operator:
                  filter.operator && omit(filter.operator, 'comparison'),
                value:
                  filter.operator?.type === DatatypeOperatorType.EXISTS ||
                  filter.operator?.type === DatatypeOperatorType.DOES_NOT_EXIST
                    ? ''
                    : value,
              }) as Filter
      ),
    })),
  })),
});

export const addDraftFields = ({
  expressions,
  ...fields
}: TopExpression): DraftTopExpression => ({
  ...fields,
  expressions: expressions.map(({ expressions, ...subExpression }) => ({
    ...subExpression,
    id: uuid(),
    expressions: expressions.map(({ filters, ...expression }) => ({
      ...expression,
      id: uuid(),
      filters: filters.map(({ ...filter }) => ({
        id: uuid(),
        ...filter,
        comparisonSubject: filter.comparisonSubject ?? null,
        comparisonOperator: filter.comparisonOperator ?? null,
        value: filter.value ?? null,
        isInvalid: {
          subject: false,
          property: false,
          operator: false,
          comparisonSubject: false,
          comparisonProperty: false,
          value: false,
        },
        tooltip: {
          subject: '',
          property: '',
          comparisonSubject: '',
          comparisonProperty: '',
          value: '',
        },
      })),
    })),
  })),
});

/**
 * check if 2 {@link DraftTopExpression}'s are equal
 *
 * (by ignoring the `id`, `isInvalid`, and `tooltip` fields)
 */
export const areDraftsEqual = (
  a: DraftTopExpression,
  b: DraftTopExpression
): boolean => isEqual(removeDraftFields(a), removeDraftFields(b));
